import { Breadcrumb } from "antd";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import { baseUrl } from "../../../components/common/baseUrl";
import { useNotify } from "../../../components/Notification";
import { settings } from "../../../utils/config";
import CreateMenuForm from "./CreateMenuForm";

const CreateMenuPage = (props) => {
  const {} = props;
  const notify = useNotify();
  const hasAccessToken = settings?.getCookie("access_token");

  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    const request = {
      name: data.name,
      slug: data.key,
      url: data.url,
      parent_id: data.parent_id || null,
      icon: data.icon,
      permission_ids: Array.isArray(data.listPermission)
        ? data.listPermission
            .map((item) => item.permission_id || item?.pivot?.permission_id || item.id)
            .filter(Boolean)
        : [],
    };
    try {
      const response = await axios.post(
        `${baseUrl}/api/v1/security/menus`,
        request,
        {
          headers: {
            Authorization: `Bearer ${hasAccessToken}`,
          },
        }
      );

      if (response.data) {
        notify.success({
          message: "Thành công",
          description: "Thêm menu thành công!",
        });
        navigate("/menu");
      }
    } catch (error) {
      const errors = error.response?.data?.errors || {};
      const errorMessages = Object.entries(errors)
        .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
        .join(" | ");
      notify.error({
        message: "Thất bại",
        description: errorMessages || "Thêm menu thất bại!",
      });
    } finally {
    }
  };
  return (
    <>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>
          <NavLink to="/menu" style={{ textDecoration: "none" }}>
            Danh sách Menu
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Thêm mới Menu</Breadcrumb.Item>
      </Breadcrumb>
      <CreateMenuForm
        handleSubmit={(data) => handleSubmit(data)}
        title={"Thêm mới Menu"}
      />
    </>
  );
};
export default CreateMenuPage;
